import type { TeamRoleModel } from '@/adapters/apiv1.g';
import type { TeamRole } from '@/types/core/team';
import type { UUID } from '@/utils/uuid';

export function extractTeamRole(model: TeamRoleModel): TeamRole {
  return {
    _rev: model._rev,
    teamRoleId: model.team_role_id as UUID | undefined,
    teamId: model.team_id as UUID | undefined,
    roleId: model.role_id as UUID | undefined,
    tenantId: model.tenant_id as UUID | undefined,
    assigned: model.assigned,
    assignedAt: model.assigned_at,
    revokedAt: model.revoked_at,
  };
}
